<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	const { class: className }: { class?: ClassValue } = $props();
</script>

<span class={["text-cmcprimary cursor-help", className]} title="Pole je povinné">*</span>
